module.exports = __webpack_public_path__ + "img/vps_picture.1b34f21.png";